import { supabase } from "@/integrations/supabase/client";

export interface FeedbackPurchaseInsert {
  user_id: string;
  video_content_id: string;
  video_comment_batch_id?: string;
  amount_cents?: number;
  status?: string;
  payment_method?: string;
  payment_reference?: string;
  notes?: string;
}

/**
 * Create a new feedback purchase record
 */
export const createFeedbackPurchase = async (purchase: FeedbackPurchaseInsert) => {
  try {
    const { data, error } = await supabase
      .from("feedback_purchases")
      .insert({
        user_id: purchase.user_id,
        video_content_id: purchase.video_content_id,
        video_comment_batch_id: purchase.video_comment_batch_id || null,
        amount_cents: purchase.amount_cents || 5000,
        status: purchase.status || 'pending',
        payment_method: purchase.payment_method || null,
        payment_reference: purchase.payment_reference || null,
        notes: purchase.notes || null,
      })
      .select()
      .single();

    if (error) throw error;
    return { success: true, data };
  } catch (error) {
    console.error("Error creating feedback purchase:", error);
    return { success: false, error };
  }
};

/**
 * Get all feedback purchases for a user
 */
export const getUserFeedbackPurchases = async (userId: string) => {
  try {
    const { data, error } = await supabase
      .from("feedback_purchases")
      .select("*")
      .eq("user_id", userId)
      .order("created_at", { ascending: false });

    if (error) throw error;
    return { success: true, data };
  } catch (error) {
    console.error("Error fetching feedback purchases:", error);
    return { success: false, error };
  }
};

/**
 * Update a feedback purchase status
 */
export const updateFeedbackPurchaseStatus = async (purchaseId: string, status: string) => {
  try {
    const { data, error } = await supabase
      .from("feedback_purchases")
      .update({ status })
      .eq("id", purchaseId)
      .select()
      .single();

    if (error) throw error;
    return { success: true, data };
  } catch (error) {
    console.error("Error updating feedback purchase:", error);
    return { success: false, error };
  }
};

/**
 * Link a batch to an existing purchase
 */
export const linkBatchToPurchase = async (purchaseId: string, batchId: string) => {
  try {
    const { data, error } = await supabase
      .from("feedback_purchases")
      .update({ video_comment_batch_id: batchId })
      .eq("id", purchaseId)
      .select()
      .single();

    if (error) throw error;
    return { success: true, data };
  } catch (error) {
    console.error("Error linking batch to purchase:", error);
    return { success: false, error };
  }
};
